
        <div class="new-order-inputs-container">
            <div class="representatives-dropdown-container" *ngIf="isRepresentative">
                <mat-form-field class="representatives-dropdown" appearance="outline" autofocus>
                    <mat-label>Select Agent</mat-label>
                    <mat-select [(ngModel)]="selectedRepresentative">
                        <mat-option *ngFor="let representative of representativeList" [value]="representative" (click)="setSelectedRepresentative(representative)">
                            {{representative.agent.name ? representative.agent.name : deafaultReprisentative.agent.name}} 
                            {{representative.agent.surname ? representative.agent.surname : deafaultReprisentative.agent.surname}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <button class="new-order-btn" mat-flat-button type="button"  (click)="openCreateNewOrderDialog()">
                <div class="new-order-content">
                    <img src="../../../../../assets/icons/add_icon.svg" alt="New Order Icon" class="new-order-icon">
                    <span><p class="new-order-text">New Order</p></span>
                </div>
            </button>

            <div class="om-search-bar">
                <div class="om-search-content">
                    <input class="om-search-text" [(ngModel)]="searchValue" placeholder="Search..." type="text" (ngModelChange)="searchOrders()">
                    <img src="../../../../../assets/order-to-cash-icons/search.svg" alt="Search Icon" class="om-search-icon">
                </div>
            </div>


            <div class="om-spacer-reset-container">
                <button mat-button="outlined" style="margin-right: 10px;" class="reset-filter-btn" (click)="resetFilter()" *ngIf="isFilterBtnVisible">Clear Filters</button>
            </div>

            <button class="filtering-btn" mat-flat-button type="button" (click)="openFilterDialog()">
                <div class="filtering-content">
                    <img src="../../../../../assets/order-to-cash-icons/tune-filter.svg" alt="Filter Icon" class="filtering-icon">
                    <span><p class="filtering-text">Filtering</p></span>
                </div>
            </button>

            
            <button class="download-report-btn" mat-flat-button type="button" (click)="openDownloadReportDialog()">
                <div class="download-report-text">
                    <img src="../../../../../assets/order-to-cash-icons/download.svg" alt="Filter Icon" class="download-icon">
                    <span><p class="filtering-text">Download Order Report</p></span>
                </div>
            </button>

        </div>

        <div class="my-order-table-container">

            <section class="my-order-table-section">

                <table mat-table [dataSource]="dataSource" class="my-order-table">

                    <!-- Order Id Column -->
                    <ng-container matColumnDef="orderNumber">
                        <th mat-header-cell *matHeaderCellDef class="my-order-top-left-cell"> Order Number </th>
                        <td mat-cell *matCellDef="let element" class="my-order-td-cell my-order-table-text">
                            <span class="is-mobile-container-om" >
                                <img *ngIf="element.isMobile" src="../../../../../assets/order-to-cash-icons/is-mobile-icon.svg" alt="Is Mobole Icon" class="is-mobile-notice-mo-icon">
                            </span>
                            {{element.displayOrderNumber ? element.displayOrderNumber : placeholder}}</td>
                    </ng-container>

                    <!-- Order No Column -->
                    <ng-container matColumnDef="ysapOrderNumber">
                        <th mat-header-cell *matHeaderCellDef class="my-order-th-cell"> SAP Order No </th>
                        <td mat-cell *matCellDef="let element" class="my-order-td-cell my-order-table-text" > {{element.ysapOrderNumber ? element.ysapOrderNumber : placeholder}} </td>
                    </ng-container>

                    <!-- Order Date Column -->
                    <ng-container matColumnDef="orderDate">
                        <th mat-header-cell *matHeaderCellDef class="my-order-th-cell"> Order Date </th>
                        <td mat-cell *matCellDef="let element" class="my-order-td-cell my-order-table-text"> {{element.orderDate ? dayjs(element.orderDate).format(dateStingFormatting) : placeholder}}  </td>
                    </ng-container>

                    <!-- Client Column -->
                    <ng-container matColumnDef="clientName">
                        <th mat-header-cell *matHeaderCellDef class="my-order-th-cell"> Client </th>
                        <td mat-cell *matCellDef="let element" class="my-order-td-cell my-order-table-text"> {{element.clientName ? element.clientName : placeholder}} </td>
                    </ng-container>

                    <!-- Order Val Column -->
                    <ng-container matColumnDef="totalPrice">
                        <th mat-header-cell *matHeaderCellDef class="my-order-th-cell"> Order Total </th>
                        <td mat-cell *matCellDef="let element" class="my-order-td-cell my-order-table-text"> {{element.totalPrice ? (element.totalPrice | currency:'R':'symbol':'1.0-2') : placeholder}} </td>
                    </ng-container>


                    <ng-container matColumnDef="orderStatus">
                        <th mat-header-cell *matHeaderCellDef class="my-order-status-td-cell"> Status </th>
                        <td mat-cell *matCellDef="let element" class="my-order-status-td-cell">
                            <span  [ngClass]="{
                                            'status-draft': element.orderStatus === 'Draft',
                                            'status-submitted': element.orderStatus === 'Submitted',
                                             'status-submitted-sap': element.orderStatus === 'Submitted to SAP',
                                             'status-pending-manager-approval': element.orderStatus === 'Pending Manager Approval',
                                            'status-rejected': element.orderStatus === 'Rejected',
                                            'status-approved': element.orderStatus === 'Approved',
                                            'status-client-approval': element.orderStatus === 'Client Approval',
                                            'status-client-rejected': element.orderStatus === 'Client Rejected',
                                            'status-submit-sap-failed': element.orderStatus === 'SAP Submission Failed',
                                            'status-edit-after-submit-to-sap': element.orderStatus === 'Submitted Update to SAP',
                                            'status-submitted-update-to-sap': element.orderStatus === 'Edit After SAP Submission',
                                            'status-pending-term-manager-approval': element.orderStatus === 'Pending Term Manager Approval',
                                            'status-recalled': element.orderStatus === 'Recalled',
                                          }">
                                 {{element.orderStatus ? element.orderStatus : placeholder}}
                            </span>
                        </td>

                    </ng-container>

                    <ng-container matColumnDef=" ">
                        <th mat-header-cell *matHeaderCellDef class="my-order-top-right-cell"></th>
                        <td mat-cell *matCellDef="let element" class="my-order-top-right-cell">
                            <img src="../../../assets/icons/chevron_right.svg" alt="Arrow Right Icon"  (click)="reviewOrder(element.id)">
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="reviewOrder(row.id)"></tr>
                </table>
            </section>

            <div *ngIf="isNoItemsFound" class="my-order-no-items-message-container">
                <div class="my-order-no-items-message">Sorry! No items found within the selected filter range.</div>
            </div>
            <div class="my-order-paginator-container-my-orders">
                <mat-paginator
                               (page)="onPaginateChange($event)"
                               [pageSize]="pageSize"
                               [pageIndex]="currentPage"
                               [pageSizeOptions]="[5, 10, 20, 50, 100]"
                               [showFirstLastButtons] = "true"
                               [length]="totalElements"
                               >
                </mat-paginator>
            </div>

        </div>
